if (!customElements.get('solid-navigation')) {
 customElements.define('solid-navigation', class extends HTMLElement {
  connectedCallback() {
   this.abort = new AbortController();
   const { signal } = this.abort;
   const closeMenus = (restoreFocus = false) => {
    this.querySelectorAll('.solid-nav-shop[open], .solid-nav-mobile[open]').forEach(menu => {
     menu.open = false;
     if (restoreFocus) menu.querySelector('summary')?.focus();
    });
   };
   this.addEventListener('click', event => { if (event.target.closest('a')) closeMenus(); }, { signal });
   document.addEventListener('click', event => { if (!this.contains(event.target)) closeMenus(); }, { signal });
   this.addEventListener('keydown', event => { if (event.key === 'Escape') closeMenus(true); }, { signal });
   window.addEventListener('resize', () => closeMenus(), { signal });
  }
  disconnectedCallback() { this.abort?.abort(); }
 });
}
